import { ChangeDetectionStrategy, Component, ElementRef, inject, model, output } from '@angular/core';
import { IMenuWithPages, MenuImageComponent } from '@core';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';

@Component({
  selector: 'app-menu-detail',
  templateUrl: 'detail.component.html',
  styleUrl: 'detail.component.scss',
  imports: [
    PageHeaderComponent,
    MenuImageComponent,
  ],
  host: {
    'class': 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailComponent {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    element: this.elementRef.nativeElement,
  };

  public readonly back = output();
  public readonly current = model.required<IMenuWithPages>();

}
